import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Box } from '@material-ui/core';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { User } from 'component/stylist_profile_header/types';
import { useAuth } from 'contexts/AuthContext';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import themes from 'styles/themes';
import { EQuizId, ESubjectQuestion, quizContextType } from 'types/quiz';
import { CREATE_ANSWER } from '../../../graph_ql/getQuiz/mutation';
import { GET_QUESTION_DATA, GET_QUIZ_RESPONSE } from '../../../graph_ql/getQuiz/queries';
import { useGetGender } from '../../../hooks/useGetGender';
import { PATH } from '../../../routes/constant';
import { useStyles } from './styles';
import withHijabIcon from './with-hijab.png';
import noHijabIcon from './no-hijab.png';
import { Spinner } from 'react-bootstrap';
import { SelectItemOverlay } from 'component/layout_quiz/select_item_overlay';
import useValidateAnswers from '../hooks/useValidateAnswers';
import { STRINGS } from '../../../constants/strings';
export interface ISkinUndertoneProps {}

const HijabQuiz = () => {
    const { userName } = useParams<{ userName: string }>();
    const { currentUser } = useAuth();
    const history = useHistory();
    const gender = useGetGender(Boolean(userName));
    const location = useLocation();
    const classes = useStyles();
    const [question, setQuestion] = useState<any>(null);
    const [currentAnswer, setCurrentAnswer] = useState<any>(undefined);
    const [currentAnswerId, setCurrentAnswerId] = useState<any>(undefined);
    const [requiredQuestion, setRequiredQuestion] = useState(true);
    const [user, setUser] = useState<User>();
    const isConsumerView = Boolean(!userName);
    const [quizData, setQuizData] = useState<any>(null);
    const isUpdate = location.pathname.includes(PATH.MY_STYLE_PREFERENCES);
    const [answerAlreadyUpdated, setAnswerUpdated] = useState(false);

    const [getQuizResponse, { loading: loadingQuiz }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted(data) {
            setRequiredQuestion(data.getQuizResponse?.questionsInfo[0]?.required);
            setQuestion(data.getQuizResponse?.questions?.question_hijab_female);
            setQuizData(data.getQuizResponse);
            const answer = data?.getQuizResponse?.answers?.question_hijab_female?.value;
            if (answer) {
                setCurrentAnswer(answer === 'true');
                setCurrentAnswerId(data?.getQuizResponse?.answers?.question_hijab_female?.id);
            }
        },
        fetchPolicy: 'network-only',
    });
    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            setUser(data.getUserByUserName);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.HIJAB,
                        contextType: quizContextType,
                        contextId: EQuizId.HIJAB,
                        userId: data.getUserByUserName?.id,
                    },
                },
            });
        },
    });

    const createAnswer = (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: String;
        valueType: String;
        isSkipped?: boolean;
    }) => {
        const variables = {
            input,
        };
        answerMutation({ variables });
    };
    const [answerMutation, { loading: loadingAnswer }] = useMutation(CREATE_ANSWER, {
        onCompleted(response) {
            onAnswerCompleted(response);
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });

    const onAnswerCompleted = async (response: any) => {
        getQuizResponse({
            variables: {
                input: {
                    quizId: EQuizId.HIJAB,
                    contextType: quizContextType,
                    contextId: EQuizId.HIJAB,
                    userId: currentUser?.uid,
                },
            },
        });
        if (location.pathname === PATH.QUIZ_MANAGER) {
            history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
        }
    };
    const { data: questionData, loading } = useQuery(GET_QUESTION_DATA, {
        variables: {
            input: {
                subject: ESubjectQuestion.HIJAB,
                paging: { page: 0, size: 0 },
                enabled: true,
            },
        },
        skip: isConsumerView ? !gender : !user,
    });

    useEffect(() => {
        if ((currentUser && isConsumerView) || gender) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.HIJAB,
                        contextType: quizContextType,
                        contextId: EQuizId.HIJAB,
                        userId: currentUser.uid || gender?.id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser.uid, gender, userName]);

    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);

    const handleClickAnswer = () => {
        const answer = {
            id: currentAnswerId,
            questionId: question.id,
            questionSubject: question.questionDataSubject,
            contextType: quizContextType,
            contextId: EQuizId.HIJAB,
            value: currentAnswer.toString(),
            valueType: 'STRING',
            questionDataIds: [questionData.getQuestionData.data[0].id],
        };
        createAnswer(answer);
    };

    const isValidAnswer = useValidateAnswers(isUpdate, currentAnswer !== undefined, answerAlreadyUpdated);

    const WithHijab = () => {
        const selected = currentAnswer === true;

        return (
            <Box
                style={{
                    border: `${selected ? '3px solid black' : '3px solid transparent'}`,
                    borderRadius: '8px',
                    backgroundColor: `${selected ? 'black' : 'transparent'}`,
                    padding: 1,
                    marginRight: 10,
                }}
            >
                <Box
                    bgcolor={'white'}
                    className={classes.quizItem}
                    onClick={() => {
                        setAnswerUpdated(true);
                        setCurrentAnswer(true);
                    }}
                >
                    <img src={withHijabIcon} className={classes.hijabImg} width={60} alt="" />
                    {selected && <SelectItemOverlay />}
                </Box>
                <p
                    className={classes.itemTitle}
                    style={{
                        color: selected ? '#F2F2F2' : '#1A1A1A',
                    }}
                >
                    YES
                </p>
            </Box>
        );
    };

    const NoHijab = () => {
        const selected = currentAnswer === false;

        return (
            <Box
                style={{
                    border: `${selected ? '3px solid black' : '3px solid transparent'}`,
                    borderRadius: '8px',
                    backgroundColor: `${selected ? 'black' : 'transparent'}`,
                    padding: 1,
                }}
            >
                <Box
                    bgcolor={'white'}
                    className={classes.quizItem}
                    onClick={() => {
                        setAnswerUpdated(true);
                        setCurrentAnswer(false);
                    }}
                >
                    <img className={classes.hijabImg} src={noHijabIcon} width={60} alt="" />
                    {selected && <SelectItemOverlay />}
                </Box>
                <p
                    className={classes.itemTitle}
                    style={{
                        color: selected ? '#F2F2F2' : '#1A1A1A',
                    }}
                >
                    NO
                </p>
            </Box>
        );
    };

    const BottomBtn = () => {
        return (
            <button
                type="submit"
                className={classes.button}
                onClick={() => {
                    handleClickAnswer();
                }}
                disabled={!isValidAnswer || loadingAnswer}
                style={{
                    backgroundColor: !isValidAnswer || loadingAnswer ? '#A3A3A3' : themes.palette.primary.main,
                }}
            >
                {location.pathname !== PATH.QUIZ_MANAGER ? STRINGS.UPDATE : STRINGS.SAVE}{' '}
                {loadingAnswer && <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />}
            </button>
        );
    };

    return (
        <CustomizeLayoutQuiz
            quizId={EQuizId.HIJAB}
            title={Boolean(!userName) ? quizData?.subTitle : ''}
            titlePage={quizData?.title}
            handleAnswer={() => {}}
            isUpdate={location.pathname === PATH.HIJAB_QUIZ}
            isDisplayContent={isConsumerView}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            requiredQuestion={requiredQuestion}
            loading={loadingAnswer}
            containerLoading={loadingQuiz || userLoading || loading}
            hideContinue
        >
            <Box textAlign={'center'} display="flex" flexDirection={'column'} width={'100%'} height={'100%'}>
                {isConsumerView && (
                    <Box
                        maxWidth="60%"
                        margin={'auto auto 8px auto'}
                        height="10%"
                        display={'flex'}
                        flexDirection="column"
                        alignItems={'center'}
                        justifyContent="center"
                    >
                        {/* <TextNormal color={themes.palette.grey['300']}>{question?.subTitle || ''}</TextNormal> */}
                    </Box>
                )}
                <Box display={'flex'} flexDirection="column" marginBottom={'auto'}>
                    <Box className={classes.quizRowContainer}>
                        <WithHijab />
                        <NoHijab />
                    </Box>
                </Box>
                <BottomBtn />
            </Box>
        </CustomizeLayoutQuiz>
    );
};
export default HijabQuiz;
